<template>
    <div>
        <van-sticky>
        <van-nav-bar :title="title">
          <template #left><van-icon @click="onBack" name="arrow-left" /></template>
          <template #right><van-icon @click="sepetegit" :badge="box" name="bag-o"/></template>
        </van-nav-bar>
      </van-sticky>
    </div>
</template>

<script>
import {router}  from '@/router';
export default {
  props: {      
     title: {
      type: String,
      default: "Ayurlife"
    },
    box: {
      type: Number,
      default: () => {
     // return JSON.parse(localStorage.getItem('osmBox')).baskets.length || 0;
      }
    },
  },
  data() {
    return {
     //box : JSON.parse(localStorage.getItem('osmBox')).baskets.length || 0
    };
  },
//   computed:{
//       routeName() {
//         const { name } = this.$route.meta.title;
//         return name; 
//     },
//   },
  methods: {
    onBack() { window.history.back();},
    sepetegit(){ router.push('/sepet')},
    // sepetadet(){ // emit için bıraktık, dönücez
    //     this.box++
    // }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/nav.vue